import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import BrandPillar from './BrandPillar';
import IntroSection from './IntroSection';
import media from '../../styles/media.style';
import Placeholder from '../../components/Placeholder';
import SectionLabel from './SectionLabel';
import { MOBILE_PADDING, SCREEN_LOCKUP_WIDTH } from '../../styles/variables.style';

const BrandPillarsWrapper = styled.div`
  margin: 0 auto 50px;
  max-width: 1260px;
  width: 100%;

  ${media.tabletL`
    margin-bottom: 140px;
  `};
`;

const BrandPillarsSection = styled.section`
  margin: auto;
  max-width: ${SCREEN_LOCKUP_WIDTH + MOBILE_PADDING * 2}px;
  padding: 40px 0 0;

  ${media.tabletL`
    padding: 40px 0;
  `};
`;

const Pillars = styled.div`
  padding: 0 ${MOBILE_PADDING}px;
  width: 100%;

  ${media.tabletP`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  `};
`;

const BrandPillars = ({ label, title, description, brandPillars }) => (
  <BrandPillarsWrapper id="our-brand-pillars-section">
    <BrandPillarsSection>
      <SectionLabel>{label || <Placeholder h="20px" w="200px" />}</SectionLabel>
      <IntroSection title={title} description={description} />
    </BrandPillarsSection>

    <Pillars>{brandPillars.map(pillar => <BrandPillar key={pillar.name || pillar.key} pillar={pillar} />)}</Pillars>
  </BrandPillarsWrapper>
);

BrandPillars.defaultProps = {
  label: undefined,
  title: undefined,
  description: undefined,
  brandPillars: undefined,
};

BrandPillars.propTypes = {
  label: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  brandPillars: PropTypes.arrayOf(PropTypes.shape()),
};

export default BrandPillars;



// WEBPACK FOOTER //
// ./src/pages/AboutPage/BrandPillarsSection.js